import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import MovieCard from "./MovieCard";

export default function MovieRow({ title, items, type = "movie" }) {
  const scrollerRef = useRef(null);
  if (!items || items.length === 0) return null;

  const scroll = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.85), behavior: "smooth" });
  };

  return (
    <section className="my-10 group/row" data-testid={`row-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-center justify-between px-4 sm:px-8 mb-3">
        <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-white tracking-tight" style={{ fontFamily: "Outfit" }}>
          {title}
        </h2>
      </div>
      <div className="relative">
        <button onClick={() => scroll(-1)} className="hidden md:flex absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-[#050505] to-transparent z-20 items-center justify-start pl-1 opacity-0 group-hover/row:opacity-100 transition" aria-label="Scroll left">
          <ChevronLeft className="text-white" size={32} />
        </button>
        <div
          ref={scrollerRef}
          className="flex gap-3 sm:gap-4 px-4 sm:px-8 overflow-x-auto no-scrollbar pb-2 pt-1 scroll-smooth"
        >
          {items.map((item, i) => (
            <MovieCard key={item.id || i} item={item} type={type} />
          ))}
        </div>
        <button onClick={() => scroll(1)} className="hidden md:flex absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-[#050505] to-transparent z-20 items-center justify-end pr-1 opacity-0 group-hover/row:opacity-100 transition" aria-label="Scroll right">
          <ChevronRight className="text-white" size={32} />
        </button>
      </div>
    </section>
  );
}
